import { Component, Input } from "@angular/core";
import { QuestionNumeric } from "src/app/main/model/forms/question-numeric.model";
import { FormCompletionBaseComponent } from "../form-completion-base.component";

@Component({
  selector: "app-question-numeric",
  templateUrl: "./question-numeric.component.html",
  styleUrls: ["./question-numeric.component.scss"],
  standalone: false,
})
export class QuestionNumericComponent extends FormCompletionBaseComponent {
  @Input() public question: QuestionNumeric;
}
